import _ from "lodash";
import {
  UNEXPECTED_ERROR,
  HIDE_UNEXPECTED_ERROR
} from "../actions/types";

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UNEXPECTED_ERROR:
      return true;
    case HIDE_UNEXPECTED_ERROR:
      return false;
    default:
      return state;
  }
};

